export default [
  {
    path: 'M832 272V428.8c-3.2 179.2-144 320-320 320S195.2 608 192 428.8V272h640v-192H44.8C19.2 83.2 0 102.4 0 128v310.4c0 35.2 3.2 67.2 9.6 102.4 6.4 32 16 64 32 92.8 12.8 32 28.8 60.8 48 86.4 19.2 25.6 38.4 51.2 60.8 73.6 12.8 12.8 28.8 25.6 41.6 38.4 9.6 9.6 22.4 16 32 25.6 25.6 19.2 57.6 35.2 86.4 48 32 12.8 64 22.4 96 28.8 32 6.4 67.2 9.6 102.4 9.6s70.4-3.2 102.4-9.6 64-16 96-28.8 60.8-28.8 86.4-48c12.8-9.6 22.4-16 32-25.6 12.8-12.8 28.8-25.6 41.6-38.4 22.4-22.4 44.8-48 60.8-73.6 19.2-25.6 35.2-54.4 48-86.4 12.8-32 22.4-64 32-92.8 6.4-32 9.6-67.2 9.6-102.4V272H832z',
    fill: '#F5AB16',
  },
]
